var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cat-img",class:{'p': !_vm.open, 'op': _vm.open, 'bot':_vm.bot}},[_c('transition',{attrs:{"name":"pop-out","mode":"out-in"}},[_c('div',{key:_vm.displayCount,class:`counter rot-${_vm.counterRotation}`},[_vm._v(_vm._s(_vm.displayCount.toLocaleString('en')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }